import { Pagination } from "./Pagination";

export class ExchangeRateEntities {
  pagination: Pagination;
  data: ExchangeRateData[];
  constructor(pagination: Pagination, data: ExchangeRateData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class ExchangeRateData {
  id = 0;
  exchangeRateFrom = "";
  exchangeRateTo = "";
  exchangeRate: any;
  status = "";
  effectiveDate = "";
  createdAt = "";
  updatedAt = "";
  createdBy = "";
  updatedBy = "";
  exchangeRateCountryNameFrom? = "";
  exchangeRateCountryNameTo? = "";

  constructor(fields?: Partial<ExchangeRateData>) {
    Object.assign(this, fields);
  }
}
